export default {
  'login.signIn': 'Login',
  'login.signOut': 'Sair',
  'login.signUp': 'Nova',

  'login.enter': 'Entrar',
  'login.back': 'Voltar',
  'login.continue': 'Continuar',

  'login.title.recover': 'Recupere a sua senha',
  'login.title.create': 'Criar Conta',

  'login.error': 'Erro',
  'login.error.invalid': 'Credenciais inválidas',
  'login.error.email': 'Email not valid',
  'login.error.emailNotFound': 'Email não encontrado.',
  'login.error.tooManyAttempts': 'Muitas tentativas. Tente novamente dentro de um minuto.',
  'login.error.nameNotValid': 'O campo nome é obrigatório',
  'login.error.emailNotValid': 'O email não é válido',
  'login.error.passwordNotValid': 'A senha deve ter 6 caracteres ou mais',
  'login.error.passwordsNotEqual': 'As senhas não conferem',

  'login.success.recovered': 'O link para alteração da sua senha foi enviado para o seu email.',
  'login.success.created': 'A nova conta foi criada com sucesso.',

  'login.label.name': 'Nome',
  'login.label.password': 'Senha',
  'login.label.confirmation': 'Confirme a nova senha',
  'login.action.linkedin': 'Continuar com LinkedIn',

  'login.text.login': 'ou fazer login normalmente',
  'login.text.newAccount': 'Ainda não tem uma conta? Crie uma.',
  'login.text.forgottenLink': 'Esqueceu a senha?',
};



/** WEBPACK FOOTER **
 ** ./src/app/modules/login/intl/pt.js
 **/